export const getLastSplittedStringItem = (fileName: string, splitBy: RegExp) => {
    const pieces = fileName?.split(splitBy) ?? [];
    return pieces.length > 0 ? pieces[pieces.length - 1] : "";
}

export const getExtension = (name: string): string => {
    if (name) {
        const nameParts = name.split(".");
        if (nameParts.length > 1) {
            return nameParts[nameParts.length - 1];
        }
    }
    return "";
};

export const removeExtension = (filename: string) => {
    if (filename?.includes(".")) {
        return filename.split(".").slice(0, -1).join(".")
    } else {
        return filename;
    }
}

export const getRelativeDocumentUrl = (url: string, isRoot: boolean) => {
    let array = url?.split("/") ?? [];
    let part = array.slice(Math.max(array.length - (isRoot ? 1 : 2), 1))
    return part.join("/");
}

export const truncateWithEllipses = (text: string, max: number) => {
    return text.substr(0, max - 1) + (text.length > max ? ' ...' : '');
}

export const createUniqueKey = () => '_' + Math.random().toString(36).substr(2, 9);

export const localStringToNumber = (textNumber: string) => {
    return Number(String(textNumber).replace(/[^0-9.-]+/g, ""));
};

export const changeExtensionToPdf = (filename: string): string => {
    if (filename) {
        let dotIndex = filename.lastIndexOf(".");
        if (dotIndex === -1) return filename + '.pdf'; // If there's no extension, just append .pdf
        return filename.substring(0, dotIndex) + '.pdf';
    }
    return "";
}

export const splitName = (fullName: string): { firstName: string, lastName: string } => {
    if (fullName) {
        let nameParts = fullName.trim().split(' ');

        let firstName: string = nameParts?.shift() || '';
        let lastName: string = nameParts?.join(' ');

        return { firstName, lastName };
    } else {
        return { firstName: '', lastName: '' };
    }
}

export const formatGuidString = (value: string): string => {
    if (value && !value.includes("-")) {
        const parts = [];
        parts.push(value.slice(0, 8));
        parts.push(value.slice(8, 12));
        parts.push(value.slice(12, 16));
        parts.push(value.slice(16, 20));
        parts.push(value.slice(20, 32));
        return parts.join("-");
    }
    return value;
}

export const splitStringByNewline = (input: string): string[] => {
    if (!input) return [];
    return input.split(/\r\n|\r|\n/);
}

export const trimCharacter = (str: string, charToTrim: string): string => {
    if (!str || !charToTrim || charToTrim.length !== 1) return str;

    const len = str.length;
    if (len === 0) {
        return "";
    }

    let startIndex = 0;
    while (startIndex < len && str[startIndex] === charToTrim) {
        startIndex++;
    }

    if (startIndex === len) {
        return "";
    }

    let endIndex = len;
    while (endIndex > startIndex && str[endIndex - 1] === charToTrim) {
        endIndex--;
    }

    if (startIndex === 0 && endIndex === len) {
        return str;
    }

    return str.slice(startIndex, endIndex);
}